import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonGroup,
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CalendarViewWeekIcon from "@mui/icons-material/CalendarViewWeek";
import CalendarViewMonthIcon from "@mui/icons-material/CalendarViewMonth";
import { useUser } from "../Contexts/UserContext";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const SideMenu = ({
  onTimeIntervalChange,
  onContextChange,
  onFilterChange,
  timeInterval,
  context,
}) => {
  const [unitDD, setUnitDD] = useState([{ UnitCode: "0", UnitName: "All" }]);
  const [branchDD, setBranchDD] = useState([{ value: "0", text: "All" }]);
  const [branch, setBranch] = useState();
  const { user } = useUser();
  const { ClientId, CompCode } = user;
  useEffect(() => {
    const fetchInitData = async () => {
      const branchData = await fetch(
        `${API_URL}/facility/GetClientUnitOnBranch/1/${CompCode}/${ClientId}/108`
      ).then((res) => res.json());
      const res = await fetch(
        `${API_URL}/facility/GetClientUnitOnBranch/3/${CompCode}/${ClientId}/108`
      ).then((res) => res.json());
      console.log(res);
      if (branchData.success) {
        console.log(branchData);
        setBranchDD([{ value: "0", text: "All" }, ...branchData.data]);
      }

      if (res.success) setUnitDD([{ value: "0", text: "All" }, ...res.data]);
    };
    fetchInitData();
  }, [ClientId]);

  const OnBranchChange = async (value) => {
    let url = "";
    if (value == "0") {
      //all
      url = `${API_URL}/facility/GetClientUnitOnBranch/3/${CompCode}/${ClientId}/108`;
    } else {
      url = `${API_URL}/facility/GetClientUnitOnBranch/2/${CompCode}/${ClientId}/${value}`;
      onFilterChange("0");
    }
    const res = await fetch(url).then((res) => res.json());
    if (res.success) setUnitDD([{ value: "0", text: "All" }, ...res.data]);
  };
  return (
    <Box
      sx={{
        padding: 2,
        bgcolor: "#eee",
        height: "90vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <ButtonGroup
        orientation="horizontal"
        // aria-label="vertical outlined button group"
        variant="contained"
        fullWidth
      >
        <Button
          onClick={() => onTimeIntervalChange("2")}
          color={timeInterval === "2" ? "secondary" : "primary"}
        >
          Day
        </Button>
        <Button
          onClick={() => onTimeIntervalChange("3")}
          color={timeInterval === "3" ? "secondary" : "primary"}
        >
          Week
        </Button>
        <Button
          onClick={() => onTimeIntervalChange("4")}
          color={timeInterval === "4" ? "secondary" : "primary"}
        >
          Month
        </Button>
      </ButtonGroup>
      <FormControl
        variant="outlined"
        sx={{ minWidth: 200, marginBottom: 1, marginTop: 1, width: "230px" }}
        size="small"
      >
        <InputLabel id="filter-label">Branch</InputLabel>
        <Select
          labelId="Branch"
          defaultValue="0"
          label="Filter By"
          onChange={(e) => OnBranchChange(e.target.value)}
        >
          {branchDD.map((ele) => (
            <MenuItem value={ele.value}>{ele.text}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl
        variant="outlined"
        sx={{ minWidth: 200, marginBottom: 2, marginTop: 1, width: "230px" }}
        size="small"
      >
        <InputLabel id="filter-label">Unit</InputLabel>
        <Select
          labelId="filter-label"
          defaultValue="0"
          label="Unit"
          onChange={(e) => onFilterChange(e.target.value)}
        >
          {unitDD.map((ele) => (
            <MenuItem value={ele.value}>{ele.text}</MenuItem>
          ))}
        </Select>
      </FormControl>
      {/* <Typography variant="h6" sx={{ marginBottom: 2 }}>
        Context
      </Typography> */}
      <ButtonGroup
        orientation="vertical"
        aria-label="vertical outlined button group"
        fullWidth
      >
        <Button
          disabled
          onClick={() => onContextChange("11")}
          color={context === "11" ? "secondary" : "primary"}
        >
          Attendance
        </Button>
        {ClientId === "1008" && (
          <Button
            onClick={() => onContextChange("8")}
            color={context === "8" ? "secondary" : "primary"}
          >
            Washroom Reports
          </Button>
        )}
        {ClientId !== "11542" ? (
          <>
            <Button
              onClick={() => onContextChange("1")}
              color={context === "1" ? "secondary" : "primary"}
            >
              Punctuality
            </Button>
            <Button
              onClick={() => onContextChange("2")}
              color={context === "2" ? "secondary" : "primary"}
            >
              Cleanliness
            </Button>
            <Button
              onClick={() => onContextChange("3")}
              color={context === "3" ? "secondary" : "primary"}
            >
              Consumable Availability
            </Button>
            <Button
              onClick={() => onContextChange("4")}
              color={context === "4" ? "secondary" : "primary"}
            >
              Hygiene
            </Button>
            <Button
              onClick={() => onContextChange("5")}
              color={context === "5" ? "secondary" : "primary"}
            >
              Security Guard
            </Button>
            <Button
              onClick={() => onContextChange("6")}
              color={context === "6" ? "secondary" : "primary"}
            >
              Competence Level
            </Button>
            <Button
              onClick={() => onContextChange("7")}
              color={context === "7" ? "secondary" : "primary"}
            >
              HK Quality
            </Button>
          </>
        ) : (
          <>
            <Button
              onClick={() => onContextChange("1")}
              color={context === "1" ? "secondary" : "primary"}
            >
              Feedback
            </Button>
          </>
        )}
      </ButtonGroup>
    </Box>
  );
};

export default SideMenu;
